import { IUserStatusRaw } from 'models/commonApi.model'

import { NO_DATA_ERROR } from 'root-constants'

export const getUserPaymentMethodFromRaw = (
  userStatusRaw: IUserStatusRaw,
): string =>
  userStatusRaw.config?.payment_method ||
  userStatusRaw.config?.paymentMethod ||
  NO_DATA_ERROR
